import { NavLink, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import type { ViewMode } from "@/hooks/useViewMode";
import { isActive, tabsFor } from "./nav";

/** The phone's tab bar. From 1024px wide the side rail (SideRail) takes over. */
export function TabBar({ mode, unread = 0 }: { mode: ViewMode; unread?: number }) {
  const { pathname } = useLocation();
  return (
    <nav aria-label="Main" className="glass fixed inset-x-0 bottom-0 z-40 border-t border-line/80 pb-safe lg:hidden">
      <ul className="mx-auto flex h-[var(--tfwp-tabbar-height)] max-w-content items-stretch">
        {tabsFor(mode).map((tab) => {
          const active = isActive(tab, pathname);
          const Icon = tab.icon;
          const badge = tab.to === "/messages" && unread > 0;
          return (
            <li key={tab.to} className="flex-1">
              <NavLink
                to={tab.to}
                aria-current={active ? "page" : undefined}
                aria-label={badge ? `${tab.label}, ${unread} unread` : tab.label}
                className={cn(
                  "relative flex h-full flex-col items-center justify-center gap-[3px] text-caption2 transition-colors duration-fast",
                  active ? "text-tint" : "text-text-tertiary hover:text-text-secondary",
                )}
              >
                <span className="relative">
                  <Icon className="h-[25px] w-[25px]" strokeWidth={active ? 2.2 : 1.75} aria-hidden />
                  {badge ? (
                    <span className="absolute -right-2.5 -top-1 min-w-[18px] rounded-full bg-critical px-1 text-center text-[10px] font-bold leading-[18px] text-white ring-2 ring-white">
                      {unread > 9 ? "9+" : unread}
                    </span>
                  ) : null}
                </span>
                {tab.label}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
